import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _CostStudy, _ImportCostSettlement, _NationalizationProcessGeneralInfo, _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { MakeUBLInvoice } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { CurrencyEditor } from "../../../../../erp/cellEditor/Currency/CurrencyEditor";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { NationalizationProcessItemsByLiquidation } from "../NationalizationProcessItems/NationalizationProcessItemsByLiquidation";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const IMP001 = ({ configProcedure }: Props) => {

    const ImportCostSettlement = useDataBean(_NationalizationProcessGeneralInfo);
    const [invoice, setInvoice] = useState<any>({});
    const [props, setProps] = useState<any>({});
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConfAdd, setModalConfAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])
    useEffect(() => {
        console.log("cargando de props => ", props.IDNationalizationProcessGeneralInfo);

        if (props.IDNationalizationProcessGeneralInfo) {
            ImportCostSettlement.instance.getNationalizationProcessGeneralInfoCatalogPorPropiedades({ IDNationalizationProcessGeneralInfo: props.IDNationalizationProcessGeneralInfo }, null).then(
                (resp: any) => {
                    if (resp.length > 0) {
                        console.log(resp[0].DataBeanProperties);
                        ImportCostSettlement.setBean(resp[0].DataBeanProperties);
                    }

                }
            )
        }
    }, [props])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(ImportCostSettlement.bean.ObservationsEC)
        }

        if (configProcedure?._pushProps) {
            let x = {
                IDNationalizationProcessGeneralInfo: ImportCostSettlement.bean.IDNationalizationProcessGeneralInfo,
                State: 1
            }
            configProcedure?._pushProps(x)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(ImportCostSettlement.bean)
        }
        toast.success('Actualizado')
    }


    const create = () => {
        ImportCostSettlement.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        editaItem()
    }

    const createvdos = () => {
        ImportCostSettlement.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        editaItemvdos()
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        ImportCostSettlement.instance.updateNationalizationProcessGeneralInfo(ImportCostSettlement.bean).then(
            (resp: any) => {
                onExportMap()
                console.log(resp)
                toast.success('Actualizado');
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const editaItemvdos = () => {

        ImportCostSettlement.instance.updateNationalizationProcessGeneralInfo(ImportCostSettlement.bean).then(
            (resp: any) => {
                console.log(resp);
                toast.success('Actualizado');
                ImportCostSettlement.setBean(resp);
                // configProcedure._pushProps({ IDNationalizationProcessGeneralInfo: resp.IDNationalizationProcessGeneralInfo, State: 1 });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <div className="row">
            <div className="col-md-12">


                <div className="row">
                    <div className="col-md-12">

                        <SelectAdquisitionContract data={{ IDAccount: ImportCostSettlement.bean.IDAccount }} idSelector={ImportCostSettlement.bean.IDAdquisitionContract} onChange={({ DataBeanProperties }) => { ImportCostSettlement.setBean({ ...ImportCostSettlement.bean, 'IDAdquisitionContract': DataBeanProperties.IDAdquisitionContract }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>No. Documento Transporte</label>
                        <input type="text" name="NoDocTransport" className="form-control" value={ImportCostSettlement.bean.NoDocTransport} onChange={ImportCostSettlement.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="LiquidationCostDateLC" label="Fecha de liquidacion de costos de la importacion" value={ImportCostSettlement.bean.LiquidationCostDateLC} setDate={(e: any) => { ImportCostSettlement.setBean({ ...ImportCostSettlement.bean, "LiquidationCostDateLC": e }) }} />
                    </div>
                    {/* <div className="col-md-6">
                        <label>Liquidaciones de costos realizadas</label>
                        <input type="text" name="NoLiquidationLC" className="form-control" value={ImportCostSettlement.bean.NoLiquidationLC} onChange={ImportCostSettlement.handleChange} />
                    </div> */}
                    <div className="col-md-6">
                        <CurrencyEditor id={ImportCostSettlement.bean.CurrencyType} onchange={(e: any) => { ImportCostSettlement.setBean({ ...ImportCostSettlement.bean, "CurrencyType": e }) }}></CurrencyEditor>
                    </div>
                    <div className="col-md-6">
                        <AccountEditor idAccount={ImportCostSettlement.bean.ReviewedByLC} label="PERSONA/USUARIO QUE HACE LA REVISION DE LIQUIDACION DE COSTOS" onChange={(acc: any) => { ImportCostSettlement.setBean({ ...ImportCostSettlement.bean, "ReviewedByLC": acc.IDAccount }); }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor idAccount={ImportCostSettlement.bean.MadeByLC} label="PERSONA O USUARIO QUE REALIZA LA LIQUIDACION DE COSTOS" onChange={(acc: any) => { ImportCostSettlement.setBean({ ...ImportCostSettlement.bean, "MadeByLC": acc.IDAccount }); }} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={createvdos}>Guardar Datos*</BasicButton>
                    </div>
                </div>
                {ImportCostSettlement.bean.IDNationalizationProcessGeneralInfo &&
                    <>
                        <div className="row">
                            {/* <PrintJson json={costestudy.bean} /> */}
                            <NationalizationProcessItemsByLiquidation IDNationalizationProcessGeneralInfo={ImportCostSettlement.bean.IDNationalizationProcessGeneralInfo} />
                        </div>
                        <div className="row">
                            <div className="col-md-6">

                                <BasicButton icon="ri-inbox-unarchive-fill" clase="btn rounded-pill btn-warning waves-effect waves-light" eventClick={create}>Finalizar*</BasicButton>
                            </div>
                        </div>
                    </>
                }
            </div>
        </div>
    )
}